import http from '../lib/http';
import {prepareRegisterItemsToRequest, prepareOrdersToRequest} from '../lib/util';

export const ONLINE_CHECK_ERROR = 'ONLINE_CHECK_ERROR';
export const ONLINE_CHECK_START = 'ONLINE_CHECK_START';
export const ONLINE_CHECK_SUCCESS = 'ONLINE_CHECK_SUCCESS';

export const FETCH_INIT_APP_ERROR = 'FETCH_INIT_APP_ERROR';
export const FETCH_INIT_APP_START = 'FETCH_INIT_APP_START';
export const FETCH_INIT_APP_SUCCESS = 'FETCH_INIT_APP_SUCCESS';

export const FETCH_ONLY_CATEGORIES_ERROR = 'FETCH_ONLY_CATEGORIES_ERROR';
export const FETCH_ONLY_CATEGORIES_START = 'FETCH_ONLY_CATEGORIES_START';
export const FETCH_ONLY_CATEGORIES_SUCCESS = 'FETCH_ONLY_CATEGORIES_SUCCESS';

export const PAY_ORDER_ERROR = 'PAY_ORDER_ERROR';
export const PAY_ORDER_START = 'PAY_ORDER_START';
export const PAY_ORDER_SUCCESS = 'PAY_ORDER_SUCCESS';

export const SEND_WAITING_ORDERS_ERROR = 'SEND_WAITING_ORDERS_ERROR';
export const SEND_WAITING_ORDERS_START = 'SEND_WAITING_ORDERS_START';
export const SEND_WAITING_ORDERS_SUCCESS = 'SEND_WAITING_ORDERS_SUCCESS';

export const SELECT_PRODUCT = 'SELECT_PRODUCT';
export const MARK_PRODUCT = 'MARK_PRODUCT';
export const INCREASE_PRODUCT = 'INCREASE_PRODUCT';
export const INCREASE_PRODUCT_HALF = 'INCREASE_PRODUCT_HALF';
export const DECREASE_PRODUCT = 'DECREASE_PRODUCT';
export const CLEAR_RECEIPT = 'CLEAR_RECEIPT';
export const SET_PCS_KEYBOARD = 'SET_PCS_KEYBOARD';
export const SET_CATEGORY = 'SET_CATEGORY';
export const SET_STATE_ONLINE = 'SET_STATE_ONLINE';
export const SET_STATE_OFFLINE = 'SET_STATE_OFFLINE';
export const SET_ALLOW_SALE = 'SET_ALLOW_SALE';
export const SET_FORBID_SALE = 'SET_FORBID_SALE';
export const WAITING_ORDERS_SET_NOT_IN_PROGRESS = 'WAITING_ORDERS_SET_NOT_IN_PROGRESS';
export const RECEIPT_LIST_MOVE = 'RECEIPT_LIST_MOVE';
export const SET_KITCHEN_PRINT_DEVICE_SETTINGS = 'SET_KITCHEN_PRINT_DEVICE_SETTINGS';

export function receiptListMove(id, isTable) {
    return {
        type: RECEIPT_LIST_MOVE,
        payload: {id, isTable}
    }
}

export function waitingOrdersSetNotInProgress() {
    return {
        type: WAITING_ORDERS_SET_NOT_IN_PROGRESS
    }
}

export function setKitchenPrintDeviceSettings(name, value) {
    return {
        type: SET_KITCHEN_PRINT_DEVICE_SETTINGS,
        payload: {name, value}
    }
}

export function setForbidSale() {
    return {
        type: SET_FORBID_SALE
    }
}

export function setAllowSale() {
    return {
        type: SET_ALLOW_SALE
    }
}

export function setStateOnline() {
    return {
        type: SET_STATE_ONLINE
    }
}

export function setStateOffline() {
    return {
        type: SET_STATE_OFFLINE
    }
}

export function clearReceipt() {
    return {
        type: CLEAR_RECEIPT
    }
}

export function setCategory(cat) {
    return {
        type: SET_CATEGORY,
        payload: cat
    }
}

export function setPcsKeyboard(key) {
    return {
        type: SET_PCS_KEYBOARD,
        payload: key
    }
}

export function increaseProductHalf(id) {
    return {
        type: INCREASE_PRODUCT_HALF,
        payload: id
    }
}

export function increaseProduct(id) {
    return {
        type: INCREASE_PRODUCT,
        payload: id
    }
}

export function decreaseProduct(id) {
    return {
        type: DECREASE_PRODUCT,
        payload: id
    }
}

export function markProduct(id, isTable) {
    return {
        type: MARK_PRODUCT,
        payload: {id, isTable}
    }
}

export function selectProduct(id) {
    return {
        type: SELECT_PRODUCT,
        payload: id
    }
}

export function onlineCheck() {
    return {
        type: 'ONLINE_CHECK',
        payload: {
            promise: getOnlineCheck()
        }
    };
}

export function sendWaitingOrder(orders, deviceId) {
    return {
        type: 'SEND_WAITING_ORDERS',
        payload: {
            promise: postWaitingOrder(orders, deviceId)
        }
    };
}

export function payOrder(data, isTable, vats, containsKitchenItems, kitchenPrint) {
    return {
        type: 'PAY_ORDER',
        payload: {
            promise: postPayOrder(data),
            data: {data, isTable, vats, containsKitchenItems, kitchenPrint}
        }
    };
}

export function fetchOnlyCategories(barId, deviceId) {
    return {
        type: 'FETCH_ONLY_CATEGORIES',
        payload: {
            promise: getOnlyCategories(barId, deviceId)
        }
    };
}

export function fetchInitApp(barId, deviceId) {
    return {
        type: 'FETCH_INIT_APP',
        payload: {
            promise: getInitApp(barId, deviceId)
        }
    };
}

async function postWaitingOrder(orders, deviceId) {
    const res = await http.post(`/app/sell-waiting-orders`, {
        query: {
            did: deviceId
        },
        body: prepareOrdersToRequest(orders)
    });
    if (res.status < 300) return res.json();
    throw res.json();
}

async function postPayOrder(data) {
    let query = {
        c: data.cashboxId,
        b: data.barId,
        d: data.discount,
        t: data.takeaway,
        pt: data.paymentType,
        did: data.deviceId,
        number: data.number,
        selltime: data.sellTime.toISOString(),
        storno: data.storno,
        note: data.note,
        srid: data.stornoReceiptId
    };

    if (!!data.branchId) {
        query['br'] = data.branchId;
    }

    const res = await http.post(`/app/sell`, {
        query: query,
        body: prepareRegisterItemsToRequest(data.items, data.discount)
    }, 5000);
    if (res.status < 300) return res.json();
    throw res.json();
}

async function getOnlyCategories(barId, deviceId) {
    const res = await http.get(`/app/only-categories/${barId}/${deviceId}`);
    if (res.status < 300) return res.json();
    throw res.json();
}

async function getInitApp(barId, deviceId) {
    const res = await http.get(`/app/app-init/${barId}`, {query: {deviceId: deviceId}});
    if (res.status < 300) return res.json();
    throw res.json();
}

async function getOnlineCheck() {
    const res = await http.get(`/app/online-check`, {query: {time: Date.now()}});
    if (res.status < 300) return res.json();
    throw res.json();
}



// WEBPACK FOOTER //
// ./src/common/categories/actions.js